import { createSlice } from '@reduxjs/toolkit'
import { logoutUser } from '../middlewares/logoutMiddleware'
import { AnswerTabs } from '../../pages/assignment/components/text-submission-drawer/content/answers/answer/Answer'
import { GradingModes } from '../../pages/assignment/components/text-submission-drawer/header/GradingModeSelect'

export const ViewModes = {
    PARSED: 'parsed',
    PDF: 'pdf',
}

const initialState = {
    expandedQuestionIds: [],
    focusedQuestionId: null,
    activeSectionKey: AnswerTabs.GRADING,
    gradingMode: GradingModes.BY_QUESTION,
    viewMode: ViewModes.PARSED,
}

const textSubmissionDrawerSlice = createSlice({
    name: 'textSubmissionDrawer',
    initialState,
    reducers: {
        setExpandedQuestionIds: (state, action) => {
            state.expandedQuestionIds = action.payload
        },
        expandQuestion: (state, action) => {
            if (state.expandedQuestionIds.includes(action.payload)) return
            state.expandedQuestionIds.push(action.payload)
        },
        setFocusedQuestionId: (state, action) => {
            state.focusedQuestionId = action.payload
            if (!state.expandedQuestionIds.includes(action.payload)) state.expandedQuestionIds.push(action.payload)
        },
        setActiveSectionKey: (state, action) => {
            state.activeSectionKey = action.payload
        },
        setGradingMode: (state, action) => {
            state.gradingMode = action.payload
        },
        setViewMode: (state, action) => {
            state.viewMode = action.payload
        },
        reset: () => initialState,
    },
    extraReducers: builder => builder.addCase(logoutUser, () => initialState),
})

export const textSubmissionDrawerActions = textSubmissionDrawerSlice.actions

export default textSubmissionDrawerSlice.reducer
